interface TabPanelProps<T> {
  value: T;
  tabValue: T;
  children?: React.JSX.Element[] | React.JSX.Element | null;
  remount?: boolean;
}

export const TabPanel = <T,>({
  value,
  tabValue,
  children,
  remount,
}: TabPanelProps<T>): React.JSX.Element | null => {
  if (remount) {
    return <>{value === tabValue && children}</>;
  }

  return <div hidden={value !== tabValue}>{children}</div>;
};
